import React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import { routes } from '../../../constants';
import { TeamInvitations } from '../app/account-settings/components';

/**
 * Responsible for on-boarding Team Member invitation for Business.
 */
const TeamInvite = ({ goTo }) => (
  <div id='onboarding'>
    <TeamInvitations
      displayExistingInvitations={true}
      confirmText={'Complete set up'}
      cancelText={'I\'ll do this later - skip this step'}
      cancelAction={() => goTo(routes.app.root)} />
  </div>
);

const mapDispatchToProps = (dispatch) => ({
  goTo: bindActionCreators(push, dispatch)
});

export default connect(null, mapDispatchToProps)(TeamInvite);



// WEBPACK FOOTER //
// ./src/containers/pages/onboarding/team-invite.js